import { extend } from 'flarum/extend';
import Discussion from 'flarum/models/Discussion';
import Badge from 'flarum/components/Badge';

export default function() {
  // Replace awaitingApproval badge with another icon
  extend(Discussion.prototype, 'badges', function(items) {
    items.replace("hidden",
      <Badge type="hidden" icon="fas fa-hourglass-half" label={app.translator.trans('flarum-approval.forum.badge.awaiting_approval_tooltip')}/>);
    items.replace("awaitingApproval",
      <Badge type="awaitingApproval" icon="fas fa-hourglass-half" label={app.translator.trans('flarum-approval.forum.badge.awaiting_approval_tooltip')}/>);
  });
}
